<template>
  <navigator-shell :showNav="false" :requestRecordingPermission="true">
    
    <div class="card-viewer-main fit" ref="cardViewer" >  
      <div v-show="state==CardViewerState.loading" class="viewer">
        <transition name="card">
         <div class="card-container loader"   > 
              <fullscreen-loader />
         </div>
         </transition>
      </div>


      <div v-show="state==CardViewerState.started" class="viewer"> 

         <div class="card-container" v-for="(cardData,index) in cards" :key="index">
            <transition :name="cardTransition">
              <card-item ref="cardItem"  class="card-item" v-if="cardIndex==index" :style="{'z-index':getCardZIndex(index)}"  :cardData="cardData" />
              <!-- :emurseContext="emurseContext" /> -->
            </transition>         
         </div>
        <transition name="lp">   
           <terms-panel @addFavorite="addFavorite" @removeFavorite="removeFavorite" :terms="encounters.allProgress" v-if="showTerms" :class="{'no-terms':encounters.animatedProgress.length==0}" @close="showTerms=false" />    
        </transition>     
      </div>

    <transition name="fade" > 

        <div v-if="state==CardViewerState.complete" >
           <lesson-end-screen 
            :completeLessonResponse="completeLessonResponse" 
            :lessonController="lessonController"
            :terms="encounters.allProgress"
            :newTerms="newTerms"             
            :termsReviewed="wordCount"
            :termsScored="scoredTotal2"
            :termsInReviewQueue="termsInReviewQueue" 
            :isLoggedIn="isLoggedIn"/> 
        </div>
     </transition>

     <transition name="fade" > 

      <div  v-if="state==CardViewerState.error" >
        <lesson-error-screen :lessonController="lessonController" />

       </div>

     </transition>

      <div ref="navBottom" id="card-viewer-nav-bottom" class="nav-bottom" v-show="state==CardViewerState.started && !showApp" >  
        <div  v-if="lessonController && lessonController.loaded  && lessonController?.segmentNavigator.useSubnavigator() && replayIndex==-1">
            <div class="section-nav" >
              <button v-for="(item,index) in lessonController.segmentNavigator.items" class="section-nav-item"  
                :class="{active:index==lessonController.segmentNavigator.index,inactive:index>lessonController.segmentNavigator.highestIndex}"
                :title="`${index+1}`" @click="peekCard(index)"></button>
                
          </div>
        </div>
        <div class="row-nav">
          <div class="row-nav-left"> 

            <div class="move-button-container">
              <transition name="flip">              
               <button  class="move-button" :class="{disabled:replayItems.length==0 || replayIndex==0 }" 
              @click="replay()"
              :disabled="replayItems.length==0 || isNavigating" >
                <icon :name="'chevron-left'" /> 
              </button> 
              </transition>
            </div>

          </div>
          <div ref="progressBar" class="bar-item" v-if="lessonController && lessonController.loaded">
             <lesson-progress-bar :lessonController="lessonController" :replayItems="replayItems" :replayIndex="replayIndex" :replaySegments="replaySegments" ></lesson-progress-bar>  
          </div>

          <div  class="row-nav-right"> 
           <div class="move-button-container">
            <transition name="flip">
            <button ref="arrowRight" id="arrow-right" class="move-button" :class="{disabled:!canContinue}" 
              @click="moveNext()" :disabled="!canContinue || isNavigating" >
              <icon :name="'chevron-right'" /> 
            </button>

              <!-- <button v-if="replayIndex!=-1" class="move-button replay" :class="{disabled:!canContinue}" 
                  @click="moveNext()" :disabled="!canContinue || isNavigating" ><svg class="bi" fill="currentColor"><use :xlink:href="icon('chevron-right')"/></svg></button> -->
            </transition>
           </div>

          </div>
        </div> 
       </div> 
 
    <!-- draggable hud items -->
    <transition name="scale">
    <div class="hud-items left"   v-show="state==CardViewerState.started" >
     <transition name="bounce-in"> 
       <!-- v-on:after-enter="showWordCountExplainer">       -->
      <div v-if="encounters.hasProgress && wordCount>0" @click="toggleShowTerms()"   >
        <progress-indicator ref="wordcount" class="hud-item btn-icon-badge wordcount mr-1" >
          <span>{{wordCount}}</span>

          <transition name="bounce-in"> 
              <span v-if="!ranExplainerTermcount && wordCount>0" class="badge-primary help badge-circle" >    
                <icon :name="'question'" />
              </span>
          </transition>
        
        </progress-indicator>
      </div>
     </transition>  

     <transition name="bounce-in" v-on:enter="showRestartExplainer" >      
       <div class="hud-item bg-dark" ref="restart" v-if="lessonController.allowRestart" @click="restartLesson">
        <icon :name="'arrow-counterclockwise'" />  
       </div>
     </transition> 
      

    </div>
    </transition>

     <!-- TODO: Fix dropdowns -->
     <div class="hud-items right d-flex" id="hud-right" v-show="state==CardViewerState.started" >
       <app-list-dropdown ref="appListDropdown" :appConfigs="apps" @openApp="openApp" :dropdownClass="'dropdown-menu-right'" />
       <profile-dropdown v-if="!lessonController.lessonOptions.isDemo"  :showName="false" :profile="profile" :menuItems="menuItems.profile"/>
       <a v-else class="btn btn-primary" href="/dashboard">
        <span v-if="!profile">Sign Up</span>
        <span v-else>Dashboard</span>
       </a>
      
     </div> 

    <!-- hud overlay is for animations -->
 
    <div class="hud-overlay" >
        <div class="d-flex p-2 justify-content-center prompt-container">
          <span v-if="replayIndex>=0" class="bg-warning p-1 text-white prompt disappear"><b>Replaying viewed cards</b></span>
           <!-- <b>{{replayItems.length}}</b>        -->
        </div>        
        <transition-group v-on:enter="animateWordlet" > 
          <div v-for="(item,index) in encounters.animatedProgress" v-bind:key="index" class="card-text animation-element word-animation" ref="wordthing" >{{item && item.text ? item.text : ''}}</div>
        </transition-group>
 
        <!-- <particles ref="particles"></particles> -->

         <audio ref="correct" src="https://emurseassets.blob.core.windows.net/cardviewer/correct.mp3" /> 
         <audio ref="incorrect" src="https://emurseassets.blob.core.windows.net/cardviewer/incorrect.mp3"/>

         <audio ref="page0" src="https://emurseassets.blob.core.windows.net/cardviewer/pageflip1.mp3" />
         <audio ref="page1" src="https://emurseassets.blob.core.windows.net/cardviewer/pageflip2.mp3" />
         <audio ref="page2" src="https://emurseassets.blob.core.windows.net/cardviewer/pageflip3.mp3"/>

         <audio ref="pluck0" src="https://emurseassets.blob.core.windows.net/cardviewer/pluck1.mp3" />
         <audio ref="pluck1" src="https://emurseassets.blob.core.windows.net/cardviewer/pluck2.mp3" />
         <audio ref="pluck2" src="https://emurseassets.blob.core.windows.net/cardviewer/pluck3.mp3" />
         <audio ref="coin0" src="https://emurseassets.blob.core.windows.net/cardviewer/coin1.mp3" />
         <audio ref="coin1" src="https://emurseassets.blob.core.windows.net/cardviewer/coin2.mp3" />
         <audio ref="coin2" src="https://emurseassets.blob.core.windows.net/cardviewer/coin3.mp3"/>
    </div>
 
    
     <app-loader v-if="showApp" :config="appConfig" @close="closeApp" key="appLoader" />
     
  </div>
  </navigator-shell>
</template>

<script lang="ts">
import { Options,Provide,Inject, Prop, Vue } from 'vue-property-decorator';
import { CardData, ReplayItem, ReplaySegment } from './CardData';
import CardItem from './CardItem.vue';
import { EntryRepository } from '@/data/repository/EntryRepository';

import  LessonProgressBar from './LessonProgressBar.vue';
import  ReplayProgressBar from './ReplayProgressBar.vue';

import {LessonController, LessonContext} from '@/controllers/LessonController';
import { ContinueResult } from '@/controllers/cards/CardBuilder';
import {TermProgressEvent} from '@/controllers/ProgressController';
import { Term } from '@/data/repository/DictionaryRepository';

import FullscreenLoader from '@/components/core/FullscreenLoader.vue'
import ProgressIndicator from './ProgressIndicator.vue';
import {SpinningWordAnimation} from './Animations'; 
import { CompleteLessonResponse, CourseRepository, LessonProgressReport, TermProgressReport, TermProgressSummary } from '@/data/repository/CourseRepository';
import LessonEndScreen from './LessonEndScreen.vue';
import LessonErrorScreen from './LessonErrorScreen.vue';

import AppListDropdown from '../shell/AppListDropdown.vue';
import AppLoader from '../shell/AppLoader.vue';
import { ShellController, safariViewportFix } from '../shell/Shell';
import { PreferencesController } from '@/controllers/PreferencesController';
import { DashboardRepository,  } from '@/data/repository/DashboardRepository';
import ProfileDropdown from '../shell/ProfileDropdown.vue';
import { CardFactory } from './types/CardFactory';
//import { LanguageFeatureTypes } from '@/languages/LanguageFeatureTypes';
import { type ILanguageFeatures } from '@/languages/LanguageFeatures';
import TermsPanel from './TermsPanel.vue'
import {CardViewerState, playElement, ProgressItemViewModel} from './CardViewer';
import { icon } from '@/components/shell/Shell'; 
import NavigatorShell from '@/components/shell/NavigatorShell.vue';
import { EmurseContext } from "@/EmurseContext";
import Icon from '@/components/core/Icon.vue'; 
import { TinyEmitter } from 'tiny-emitter';
import { TermPractice } from '@/data/repository/ProgressRepository';
import { ProfileInfo } from '@/data/repository/UserInfo';

@Options({components:{CardItem, LessonProgressBar, ReplayProgressBar, ProgressIndicator,ProfileDropdown,
                      FullscreenLoader,Icon,
                    LessonEndScreen,LessonErrorScreen, AppListDropdown,AppLoader, TermsPanel, NavigatorShell}})
export default class CardViewer extends Vue { 
  public getIcon
  =icon;

    public isNavigating = false;
   
   @Inject() public apps!: any[];
   @Inject() public profile!: ProfileInfo;
   @Inject() public lessonController!: LessonController;
   @Inject() public entryRepository!: EntryRepository; 
   @Inject() public courseRepository!: CourseRepository;
   @Inject() public dashboardRepository!: DashboardRepository;
   @Inject() public shellController!: ShellController;
   @Inject() public preferencesController!: PreferencesController;
   @Inject() public emurseContext!: EmurseContext;

   @Provide("cardFactory") public cardFactory: CardFactory = new CardFactory();

   //@Inject() public languageFeatureTypes!: LanguageFeatureTypes;
   @Provide("languageFeatures") public languageFeatures!: ILanguageFeatures;

   public CardViewerState = CardViewerState;

   //view model
   public menuItems: any =  {};
   public showApp = false;
   public appConfig: any | null = null;

   //proxy for LessonProgress object in LessonController lesson progress
   public lessonContext!: LessonContext;
   
   //view only tracking
   protected _cardIndex=-1;
   protected _peekIndex = -1;
   public replayIndex= -1;

   //deprecate scored total if bad
   public scoredTotal=0;
   public scoredTotal2 = 0;
   public termsInReviewQueue=0;

   public wordCount=0;
 
   public encounters: ProgressItemViewModel = new ProgressItemViewModel();
   public state=CardViewerState.loading;

   public completeLessonResponse: CompleteLessonResponse | null = null;

   public showTerms = false;
   public cards: CardData[] = [];
 
   public replayItems: ReplayItem[] =[]
   public replaySegments: ReplaySegment[] = [];

   //
   public newTerms = 0;

   //explainer settings
   public ranExplainerTermcount = false;

   public get isLoggedIn(): boolean
   {
     return this.profile ? true : false;
   }

   public isDrill(): boolean
   {
     return this.lessonController.lessonOptions?.mode?.endsWith("drill");
   }

   public getCardZIndex(index: number)
   {
      const ci = this.cardIndex;

      if (ci<this.cards.length) {
        return 1;
      }
      else {
        return 'auto';
      }
   }

   public get cardIndex(): number
   {
      if (this._peekIndex>=0)
      {
        return this._peekIndex;
      }
      else {
        return this._cardIndex;

      }
   }
 
   public peekCard(index = 0)
   {
     const peekIndex = this.lessonController.segmentNavigator.baseIndex + index;
      
     if (peekIndex<this.cards.length)
     {
       this.cardTransition=(peekIndex<this.cardIndex) ? "card-back" : "card";
       this.setPeekIndex(peekIndex);
     }

   }

   public closeApp()
   {
     this.showApp=false;
     this.appConfig=null;
   }

   public openApp(app: any)
   {
     this.showApp=true;
     this.appConfig=app;
   }

  //  public get emurseContext()
  //  {  
  //    return this.lessonController.context;
  //  }
 
   
   public cardTransition = "card";

   public replay()
   {
    this.cardTransition="card-back";
    
     if (this.replayItems.length>0)
     {
      if (this.replayIndex==-1)
      {
        this.replayIndex = this.replayItems.length-1;
      }
      else if (this.replayIndex>0) {
        this.replayIndex--;
      }

      this._peekIndex = this.replayItems[this.replayIndex].index;
    }

   }

   public showNextReplayCard()
   {
      const showReplay = this.replayIndex+1;
      if (showReplay>=this.replayItems.length)
      {
        this.replayIndex = this._peekIndex = -1;
      }
      else {
        this.replayIndex=showReplay;
        this._peekIndex = this.replayItems[showReplay].index;
      }
       

   }

   private setPeekIndex(nextPeek: number)
   {
      this._peekIndex=nextPeek;
      this.lessonController.segmentNavigator.index= nextPeek-this.lessonController.segmentNavigator.baseIndex;
      this.$forceUpdate();
   }

   public moveNext()
   {
    this.cardTransition="card";


     if (this.replayIndex!=-1)
     {
       this.showNextReplayCard();
     }
     else if (this._peekIndex>=0) 
     {
       const nextPeek = this._peekIndex+1;
       
       //move to the next segment
       if (nextPeek>=this.cards.length)
       {
        this.replayIndex = this._peekIndex = -1;
        this.showNextCard();
       }
       else {
          this.setPeekIndex(nextPeek);
       }
     }
     else {
      this.showNextCard();
     }
   }

   public showNextCard()
   {
     this.isNavigating = true; 

     if (this.currentCard)
     {
          this.currentCard.continue().then( (continueResult: ContinueResult)=>{
      
          this.shellController.stopAllPlayback();

          if (continueResult.action=="scored")
          {
            const audioElement: HTMLAudioElement = (this.currentCard.score==1 ? this.$refs.correct : this.$refs.incorrect)  as HTMLAudioElement
            this.playElement(audioElement);        
            this.scoredTotal++;
          }
       
          if (continueResult.shouldMoveNext) {
              this.cardEnding().then(() => {

                  this.getNextCard().then(()=>{
                    this.isNavigating = false; 
                })

              })
          }
          else
          {
              this.isNavigating = false;
          }
        });

     }
     else {
      this.shellController.stopAllPlayback();
     }



   }
 

   private p = 0; 
   private _sfxVolume = 0.40;
   private _audioEvents = new TinyEmitter();
 
   
   public pluckIt()
   {
     const coinNum: number= Math.floor(Math.random() * 3);   
     const pluck: HTMLAudioElement = this.$refs['pluck'+this.p] as HTMLAudioElement;
     const coin: HTMLAudioElement = this.$refs['coin' + coinNum] as HTMLAudioElement;

     pluck.volume = this._sfxVolume;
     coin.volume =  this._sfxVolume;

     this.playElement(pluck);
     this.playElement(coin);
 
     if (++this.p>=3) this.p=0;
   }
 

   protected playElement(el: HTMLAudioElement)
   {
     let sfx= this.preferencesController.getNumber("lesson.sfx",1.0);    
     playElement(el, sfx)
   }

   protected startLesson()
   { 
       //stub code
      this.getNextCard().then((card)=>{
        if (card) {
          setTimeout(()=>{
            this.runCardViewerExplainer();
          },500);
        }
    })

   }

   protected runCardViewerExplainer()
   {
      //const showUi1= !this.preferencesController.getBoolean("cardviewer.explain.ui1",false); 
      const showApps= !this.preferencesController.getBoolean("cardviewer.explain.apps",false); 
      const hasApps = this.apps && this.apps.length>0;

      if (hasApps)
      { 
       
        let items:   any[] = []

        //explainers for ui
        // if (showUi1)
        // {
        //    const progressBar = this.$refs.progressBar as HTMLElement;
        //   items = items.concat([ 
        //                                              {title:"Emurse Lessons", text: "This is the lesson viewer. Lesson content will be presented here. Let's look at how get around.", el: null},
        //                                               {title:"Navigation", text: "This is the progress bar.  It shows you where you are in the lesson.  The dotted lines represent the sections within a lesson.", el: progressBar}, 
        //                                               {title:"Navigation", text: "When this arrow is enabled, you can advance to the next part of the lesson.",el:this.$refs.arrowRight as HTMLElement},
        //                                               {title:"Card History", text: "When enabled, you can look back at replayable cards you've viewed in this session. Card history may be disabled at certain points within a lesson, such as within a scored exercise.", icon:"clock-history", el:this.$refs.replay as HTMLElement}
        //   ]);
        // }

        //explainers for app
        if (showApps)
        {
          const appsIcon = (this.$refs.appListDropdown as any).$el as HTMLElement;
          items=items.concat([{title:"You Have Apps Available", text: "Apps contain useful functionality to help on your language-learning journey.  You can view your apps by clicking here.",
           el: appsIcon}])
        }

        this.shellController.explainer.explainItems(items).then(completed=>{
          if (showApps) this.preferencesController.setPreference("cardviewer.explain.apps",true);
        });
      }
      
   }
 
    
   //animation handlers
   public showWordCountExplainer(): Promise<void>
   { 
     
    return new Promise<void>((resolve)=>{

      if (this.encounters.hasProgress && this.$refs.wordcount &&  !this.preferencesController.getBoolean("cardviewer.explain.wordcount",false))
      {
        this.$nextTick(()=>
          {
            const wordcount =  (this.$refs.wordcount as any).$el as HTMLElement;
            let items: any[] = [  
              { text: "This indicator shows how many words or phrases you have encountered in this lesson. Click or tap to open the list.", el: wordcount} 
            ]
            this.shellController.explainer.explainItems(items).then(completed=>{
              this.preferencesController.setPreference("cardviewer.explain.wordcount",true);
              resolve();
            });
          });
      }
      else {
        resolve;
      }

    }); 
   }

   public showRestartExplainer(e: any)
   { 
 
    if ( this.$refs.restart &&  !this.preferencesController.getBoolean("cardviewer.explain.restart",false))
     {
       this.$nextTick(()=>
        {
          const restart =  (this.$refs.restart as any) as HTMLElement;
          //                        icon:'arrow-counterclockwise',
          let items: any[] = [ 
                        {title:"Lesson Resumed", text: "You have resumed this lesson. Continue from here, or click/tap the lesson restart icon in the top left corner to view cards before this point.",

                         el: restart} 
            ]
          this.shellController.explainer.explainItems(items).then(completed=>{
             this.preferencesController.setPreference("cardviewer.explain.restart",true);
          });
        });
     }

   }

   public restartLesson()
   {
    this.shellController.loading("restart");
    this.courseRepository.restartLesson(this.lessonController.lesson.uid).then(()=>{
      this.shellController.reload();
    }).catch(()=>{
      this.shellController.loading("restart",false);
    })
   }

   public toggleShowTerms()
   {
    let toggleTermsPromise = new Promise<void>( (resolve)=>{
      resolve();
    });

    if (!this.ranExplainerTermcount)  toggleTermsPromise = new Promise<void>( (resolve)=>{
      this.showWordCountExplainer().finally(()=>
      {
        this.ranExplainerTermcount=true;
        resolve();
      });
    });

    if (!this.showTerms)
    {
      toggleTermsPromise.then(()=>{

        if (this.encounters?.animatedProgress)
      {
        const termsById: any={};
        const missingTerms: any[] =[];
        this.encounters.animatedProgress.forEach(p=>{
          
          this.emurseContext.setFavoriteStatus(p);

          if (!p.definition && !p.entryTranslation)
          {
            termsById[p.id] = p;
            missingTerms.push(p);
          }
        });

      
        this.showTerms=true;
        this.entryRepository.getTermDetailFromTerms(missingTerms).then(terms=>{
          terms.forEach(t=> {
            const term = termsById[t.id];

            if(term) {
              this.emurseContext.setFavoriteStatus(term);

              if (t.definition) {
                term.definition=t.definition;
              }
              else if (t.entryTranslation)
              {
                term.entryTranslation=t.entryTranslation;
              }
            }
          })
        }) 

      }
      else {
              this.showTerms=true;
      }

      })
 
    }
    else {
      this.showTerms=false;
    }



   }
 

   protected onEncounter(termProgressEvent: TermProgressEvent)
   { 
     for(let i=0;i<termProgressEvent.terms.length;i++) {
       this.emurseContext.setFavoriteStatus(termProgressEvent.terms[i]);
       this.encounters.queueProgress(termProgressEvent.terms[i],termProgressEvent);
     }

     if (termProgressEvent.type=="instant")
     {
       this.encounters.applyProgress().then(()=>{
        this.wordCount = this.encounters.allProgress.length;
       })

     }
   }

   protected onEncounterUpdate(encountersUpdated: any)
   {
    let progressResult = encountersUpdated.progressResult;
    let termsMap: any = {};

    for(let i in progressResult)
    {
      let encounter = progressResult[i];
      let term: any = this.encounters.getItem(i);
      term.encounter = encounter;

      if (encounter?.timesEncountered<=1 && !term.isNew) {
          term.isNew = true;
          this.newTerms++;
          //this.newTermsByTid[term.tid] = term;
      }



    }

   }

   public applyPractice(termPractice: TermPractice[])
   {
    for (let i=0;i<termPractice.length;i++) {
      let p = termPractice[i];
      let term= this.encounters.getItem(p.tid);
      term.practiced = !term.practiced ? 1 : term.practiced+1;
      this.scoredTotal2++;
    } 
    

   }

   public onPractice(termProgressEvent: TermProgressEvent)
   {
    if (termProgressEvent.practice!=null)
    {
      this.applyPractice(termProgressEvent.practice);
    }
   }

   public get currentCard(): any
   {
      return this.cards[this._cardIndex]?.data;
   }
 
   public get canContinue(): boolean
   {
     //if you can peek then yeah.
     if (this._peekIndex>=0)
     {
      return true;
     }
     else if (this._cardIndex>=0 && this._cardIndex<this.cards.length) {
       
      return this.currentCard.canContinue;
     }
     else {
      return false;
     }
   }

   protected cardEnding(): Promise<any>  {
     return new Promise<any>( (resolve,reject)=>{
        const audioNum= Math.floor(Math.random() * 3);            
        const audioElement: HTMLAudioElement = this.$refs['page'+audioNum] as HTMLAudioElement;
       
        this.playElement(audioElement);

        //TODO: probably better to just return promises and let them
        //both resolve
         this.encounters.applyProgress().then(()=>{
          this.wordCount = this.encounters.allProgress.length;
           resolve(true);
         })
        // const min=100;
        // setTimeout(()=>{
        //   //done with our end animation stuff
        //   resolve(true);
        // }, progressAnimationDuration<min ? min : progressAnimationDuration)
     });

 

   }

   protected getNextCard(): Promise<any>
   {
     return new Promise<any>( (resolve,reject)=>{
  
        if (!this.lessonController.lessonCompleted)
        {

          if (this.lessonController.segmentNavigator.canReplay && this.cardIndex>=0)
          {
            const replayItem = new ReplayItem();
            replayItem.index=this.cardIndex;
            replayItem.navigator = this.lessonController.segmentNavigator;
            replayItem.navigatorIndex = this.lessonController.segmentIndex;
            this.replayItems.push(replayItem); 

            if (!this.replaySegments[replayItem.navigatorIndex])
            {
              const replaySegment= new ReplaySegment();
              replaySegment.startIndex=this.replayItems.length-1;
              this.replaySegments[replayItem.navigatorIndex] =replaySegment;
            }

            this.replaySegments[replayItem.navigatorIndex].replayItems.push(replayItem);

          }

          this.lessonController.getNextCard(this._cardIndex+1).then(card=>{
              if (card)
              {
                  if (card.data.events) {
                    //if the card requests to continue, try
                    card.data.events.on("continue",()=>{
                      this.moveNext();
                    })
                  }

                this.cards.push(card);
                this._cardIndex++;
                card.cardIndex=this._cardIndex;
              }

              resolve(card);
          });

        } 
        else {
          //lesson completed 
          resolve(null);
      }
          
     }); 


   }

   public created()
   { 
      if (!this.lessonController.lessonOptions.isDemo)
      {
        this.dashboardRepository.getProfileMenu().then(m => {
            this.menuItems = m;
        });
      }
 
     const initialize = ()=>{
        this.state= CardViewerState.started;
        this.lessonContext = this.lessonController.lessonContext;
        //set up progress in the VM
        Promise.allSettled([
            this.cardFactory.loadLanguagePacks(this.lessonController.lesson.language)
            //,this.loadLanguageFeatures(this.lessonController.lesson.language)
            ])
        .then(()=>{
          //TODO: there are a lot of different types being passed around.  Some are in context, 
          //some are being injected.  we should be using them from the context, where appropriate
          //lessonController should be updated to use the context not have languageFeatures as its own property. 
            this.startLesson();
        }).catch(error=>{
          //console.error(error);
          throw error;
        })
     };

     if (this.lessonController.loaded)
     {
      initialize();
     }
     else if (this.lessonController.loadError)
     {
      this.state = CardViewerState.error;
     }
     else { 
       //attach event handlers
       this.lessonController.events.on("lessonReady",()=>{  
        initialize();
       });

       this.lessonController.events.on("loadLessonError",()=>{  
        //what?
        this.state = CardViewerState.error;
       });
 
     }
 
    //listen in to relevant events     
    this.lessonController.events.on("encounter",this.onEncounter);
    this.lessonController.events.on("encounter-update", this.onEncounterUpdate)
    this.lessonController.events.on("practice",this.onPractice);
    this.lessonController.events.on("lessonCompleted",this.lessonCompleted); 

      window.addEventListener("keydown", this.keyDown );
      window.addEventListener("keyup", this.keyUp );

   }

   protected destroyed()
   {
     window.removeEventListener("keydown", this.keyDown );
     window.removeEventListener("keyup", this.keyUp);
   }

   protected keyUp(ev: KeyboardEvent)
   {
    const key = ev.key; 
    const card = this.currentCard;

     if (key=="ArrowRight")
      {
        this.moveNext();
      }
      else if (key=="ArrowLeft")
      {
        this.replay();
      }
      else if (card && key!=" " && Number(key)>=0 && Number(key)<=9 && card.selectChoiceByNumber  )
      { 
          card.selectChoiceByNumber(key);
      }      
      else if (card && card.events)
      { 
        card.events.emit("keyUp", key)
      }
   }

   protected keyDown(ev: KeyboardEvent)
   {
    const key = ev.key; 
    const card = this.currentCard;

      if (card?.events)  
      { 
        card.events.emit("keyDown", key);
      } 
   }
   
   protected lessonCompleted()
   { 
     
      this._cardIndex++;
      this.state=CardViewerState.complete; 

      const getCompleteLessonResponse = ()=>{
        const completeLessonResponse = new CompleteLessonResponse();
 
        return completeLessonResponse;
      }

      if (this.lessonController.options.isDemo)
      {
        this.completeLessonResponse = new CompleteLessonResponse();
      }
      else if (this.lessonController.lesson.segments.length>0 && 
          (this.lessonController.lessonOptions.mode=="lesson" || this.lessonController.lessonOptions.mode=="practice" ) )
      { 
        this.courseRepository.completeLesson(this.lessonController.lessonUid, this.lessonController.courseUid).then((response)=>{
          this.completeLessonResponse = response;
        });
      }
      else if (this.lessonController.lessonOptions.mode=="review")
      {        
        const getCardsDue = ()=>{
          this.courseRepository.getCardsDueCount(this.lessonController.courseUid).then(due=>{
            const response  =  getCompleteLessonResponse();
            this.termsInReviewQueue = due;
            this.completeLessonResponse =response;
          })
        }

        if (this.lessonController.progressController)
        {
          this.lessonController.progressController.allProgressSubmitted().then(()=>{
            getCardsDue();
          })
        }


      }
      else { 
        this.completeLessonResponse = getCompleteLessonResponse();;
      } 
   } 


   public animateWordlet(w: any)
   {  
        const animation: SpinningWordAnimation = new SpinningWordAnimation();
        let incrementWordCount = false;
        
        if (this.wordCount==0)
        {
          this.wordCount=1;
        }
        else {
          incrementWordCount = true;
        }

        this.$nextTick(()=>{
          animation.animateWordlet(w as Element, this.$refs.wordcount as ProgressIndicator).then(()=>{
            this.pluckIt();
            if (incrementWordCount && this.wordCount+1<this.encounters.allProgress.length) this.wordCount++; 
          }); 

        });

   }
  
    public resize()
    {

        const cardViewer = this.$refs.cardViewer as HTMLElement;
        const cardViewerHeight = cardViewer.clientHeight;        
        let ch=(this.$refs.navBottom as HTMLElement).clientHeight;

        if (ch<=0) ch=40;

        cardViewer.style.setProperty('--navbottom', `${ch}px`);
        cardViewer.style.setProperty('--card-viewer-height', `${cardViewerHeight}px`);        
   
    }
 
   private eventsAttached = false;
   public mounted()
   {
      safariViewportFix();

      this.ranExplainerTermcount=this.preferencesController.getBoolean("cardviewer.explain.wordcount",false); 

    

      if (!this.eventsAttached)
      {
         this.eventsAttached=true;
         window.addEventListener("resize",this.resize);
         this.resize();

         this.$nextTick(()=>{
               this.resize();

               setTimeout(()=>{
                  if (this.lessonController.allowRestart) {
                  this.showRestartExplainer(null);
                  }
               },500);

         });

         

      }
   }

   public addFavorite(term: Term)
   {
      const language=this.languageFeatures.language();
      this.emurseContext.appendFavorite({id: term.id, type: term.type} as Term, language );
   }

   public removeFavorite(term: Term)
   {
      const language=this.languageFeatures.language();
      this.emurseContext.removeFavorite({id: term.id, type: term.type} as Term, language );
   }

   
   
}
</script>

<style lang="scss" scoped>
 @import './Cards.scss';

 .hud-overlay {
   z-index:5000; //TODO: appropriate z indexes
   pointer-events: none; 
   position:absolute;
   top:0;
   bottom:0;
   left:0;
   right:0;
   overflow: hidden;
 }

 .overlay-prompt {
  width:100%;
 }
  
  .animation-element {
    position:absolute;
    position: absolute;
    left:50%;
    bottom:50px;
    padding:20pt;
    border-radius: 10pt;
    color:white;
    background:$blue;
    text-shadow: 5px 5px 48px rgba(0, 0, 0, 0.5)  ;  
    font-size:48pt;
  }

  .nav-bottom,
  //.hud-bg,
  .hud-items 
  {
    z-index: 3;
  }

//  .hud-bg {
//   position: absolute;
//    padding:10pt;
//    width:100%;
//    background:$white;
//  }

//   .hud-bg,

 .hud-items {
   position: absolute;
   padding:10pt;
   display: flex;
   background:radial-gradient(white, white,transparent  );
 
   &.left {  
    left:0;   
   }

   &.right {
     right: 0;
     
   }

   .hud-item {
     cursor: pointer;
     display: flex;
     justify-content: center;
     align-items: center;
     background:$blue;
     width:2.75rem;
     height: 2.75rem;
     border-radius: 50%;
     text-align: center;
     color:$white;
     transition: transform;


     
     &.increasing {
       transform: scale(1.5);
       transition:all .25s ease-out;
     }
   }

   
 
 }

 .grow-enter-active
 {
   transform:scale(0);
   transition: transform .25s ease;
}
 
.grow-enter-to { 
    transform: scale(1);
}


.lp-enter-active { 
  transition: transform .5s ease;     

}
 
.lp-enter {
  transform: translateX(-100%);
}
 
.lp-leave-active {
  transition: transform .5s ease;     
  transform: translateX(-100%);
}

@keyframes bounce-out{
  0% {
    transform:  scale(1);
  }
  50% {
    transform:  scale();
  }
  100% {
    transform: scale(1);
  }
}

    .fit {
        max-width: 100%;
        overflow-x: hidden;
    }

</style>
